import token, { tokenToVars } from '../token';
import Common from './common';

export { Common };
export default tokenToVars(Common, token);
